import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject, Subtopic, Theme, Topic } from 'src/models';
import { RestApiService } from './rest-api.service';

@Injectable({
  providedIn: 'root'
})
export class SubjectService extends RestApiService {
  //Variáveis
  private _urlSubjects = '/subjects';
  private _urlSubject = '/subjects/:subjectId';

  private _urlTopics = '/topics';
  private _urlTopic = '/topics/:topicId';
  private _urlTopicsBySubjectId = '/subjects/:subjectId/topics';

  private _urlSubtopics = '/subtopics';
  private _urlSubtopic = '/subtopics/:subtopicId';

  private _urlThemes = '/themes';
  private _urlTheme = '/themes/:themeId';
  private _urlThemesSubtopicsBySubjectId = '/themes?filter={"include":"subtopics", "where":{"subjectId"::subjectId}}';

  constructor(public http: HttpClient) {
    super(http);
  }

  ///////////////////////////////
  //////////////////// DISCIPLINA
  ///////////////////////////////
  getSubjects() {
    const url = this._urlSubjects;
    return this.get(url, Subject) as Observable<Subject[]>;
  }

  createSubject(subject: Subject) {
    const url = this._urlSubjects;
    return this.post(url, subject, Subject);
  }

  getSubject(subjectId: number) {
    const url = this._urlSubject.replace(':subjectId', subjectId.toString());
    return this.get(url, Subject) as Observable<Subject>;
  }

  updateSubject(subject: Subject) {
    const url = this._urlSubject.replace(':subjectId', subject.id.toString());
    return this.put(url, subject, Subject);
  }

  deleteSubject(subject: Subject) {
    const url = this._urlSubject.replace(':subjectId', subject.id.toString());
    return this.del(url, Subject);
  }


  ///////////////////////////
  //////////////////// TÓPICO
  ///////////////////////////
  getTopics(topicIds?: Array<number>) {
    let url = this._urlTopics;
    if (topicIds) url += `?filter={"where":{"id":{"in":[${topicIds}]}}}`;
    return this.get(url, Topic) as Observable<Topic[]>;
  }

  createTopic(topic: Topic) {
    const url = this._urlTopics;
    return this.post(url, topic, Topic);
  }

  getTopic(topicId: number) {
    const url = this._urlTopic.replace(':topicId', topicId.toString());
    return this.get(url, Topic) as Observable<Topic>;
  }

  updateTopic(topic: Topic) {
    const url = this._urlTopic.replace(':topicId', topic.id.toString());
    return this.put(url, topic, Topic);
  }

  deleteTopic(topic: Topic) {
    const url = this._urlTopic.replace(':topicId', topic.id.toString());
    return this.del(url, Topic);
  }

  getTopicsBySubjectId(subjectId: number) {
    const url = this._urlTopicsBySubjectId.replace(':subjectId', subjectId.toString());
    return this.get(url, Topic) as Observable<Topic[]>;
  }


  //////////////////////////////
  //////////////////// SUBTÓPICO
  //////////////////////////////
  createSubtopic(subtopic: Subtopic) {
    const url = this._urlSubtopics;
    return this.post(url, subtopic, Subtopic);
  }

  deleteSubtopic(subtopic: Subtopic) {
    const url = this._urlSubtopic.replace(':subtopicId', subtopic.id.toString());
    return this.del(url, Subtopic);
  }


  /////////////////////////
  //////////////////// TEMA
  /////////////////////////
  getThemes() {
    const url = this._urlThemes;
    return this.get(url, Theme) as Observable<Theme[]>;
  }

  createTheme(theme: Theme) {
    const url = this._urlThemes;
    return this.post(url, theme, Theme);
  }

  getTheme(themeId: number) {
    const url = this._urlTheme.replace(':themeId', themeId.toString());
    return this.get(url, Theme) as Observable<Theme>;
  }

  updateTheme(theme: Theme) {
    const url = this._urlTheme.replace(':themeId', theme.id.toString());
    return this.put(url, theme, Theme);
  }

  deleteTheme(theme: Theme) {
    const url = this._urlTheme.replace(':themeId', theme.id.toString());
    return this.del(url, Theme);
  }

  getThemesBySubjectId(subjectId: number) {
    const url = this._urlThemesSubtopicsBySubjectId.replace(':subjectId', subjectId.toString());
    return this.get(url, Theme) as Observable<Theme[]>;
  }

}
